export default __webpack_public_path__ + "8eda1a06f42488d12a6139a784664c47.png";